import React from 'react';

import NotesWrapper from './Components/Notes-Wrapper/Notes-Wrapper.Component';

import './App.scss';

const App = () => {
    return (
        <div className="app">
            <NotesWrapper />
        </div>
    );
};

export default App;
